export default [
  {
    path: '/cock-balance-report',
    name: 'cock-balance-report',
    component: () => import('@/views/cockBalanceReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.cockBalanceReport',
      resource: 'balance-report',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listCockBalanceReport',
          active: true,
        },
      ],
    },
  },
]
